export const contactsData = {
    email: 'salonitomar5813@gmail.com',
    phone: '+91-8349469395',
    address: 'Pune, India',

    sheetAPI: ''
}